import {enUS, fr as frBE, nl as nlBE} from 'date-fns/locale'
import {stringify} from 'querystring'
import {encodeQueryParams, useQueryParams} from 'use-query-params'

export const stripEmptyProperties = (obj: {[key: string]: any}) => {
	const res = {}
	Object.entries(obj).forEach(([key, value]) => {
		if (!value) return
		if (!Array.isArray(value) && typeof value === 'object')
			return (res[key] = stripEmptyProperties(value))
		res[key] = value
	})
	return res
}

const bag = (config, apply, query) => ({
	query,
	set(partial) {
		return bag(config, apply, {...query, ...partial})
	},
	get(key) {
		return query[key]
	},
	toggle(partial) {
		const res = {}
		Object.entries(partial).forEach(([key, value]) => {
			const index = query[key] ? query[key].indexOf(value) : -1
			if (index > -1) {
				const copy = query[key].slice()
				copy.splice(index, 1)
				res[key] = copy
			} else {
				res[key] = (query[key] || []).concat(value)
			}
		})
		return bag(config, apply, {...query, ...res})
	},
	active(partial) {
		return Object.entries(partial).reduce(
			(acc, [key, value]) =>
				acc && query[key] && query[key].indexOf(value) > -1,
			true
		)
	},
	apply() {
		apply(query)
	},
	toString() {
		return `?${stringify(
			encodeQueryParams(config, stripEmptyProperties(query))
		)}`
	}
})

export const useFilter = config => {
	const [query, setQuery] = useQueryParams(config)
	return bag(config, setQuery, query)
}

export const getLocale = (lang: string) => {
	switch (lang.toLowerCase()) {
		case 'nl':
			return nlBE
		case 'fr':
			return frBE
		default:
			return enUS
	}
}
